// extracted by mini-css-extract-plugin
export default {"details_categories_item":"style_details_categories_item__RBGZU","details_simple":"style_details_simple__86GBK"};